<template>
  <div class="home">
    <div class="home__hero">
      <p class="home__sub">매일, 지금 이 순간을 기록하세요.</p>
      <h1 class="home__title">JUST 2 DAYS</h1>
    </div>
    <div class="btn-wrap">
      <button class="btn btn--primary" @click="$router.push('/loginPage')">시작하기</button>
      <button class="btn btn--outline" @click="$router.push('/memberdescribe')">회원가입</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homePage',
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 104px);
  padding: 4rem 0;
}
.home__hero {
  text-align: center;
  margin-bottom: 3rem;
}
.home__sub {
  font-size: 1.3rem;
  color: var(--color-text-sub);
  margin-bottom: 1rem;
  font-weight: 400;
}
.home__title {
  font-size: 3.2rem;
  font-weight: 900;
  color: var(--color-accent);
  letter-spacing: 0.12em;
}
</style>
